(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[215,4155],{

/***/ 94301:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
__webpack_require__(66477);
module.exports = self.fetch.bind(self);


/***/ }),

/***/ 50215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ SearchBar; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(49376);
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__(88674);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(47042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(21249);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__(73210);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.parse-int.js
var es_parse_int = __webpack_require__(91058);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(74916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.search.js
var es_string_search = __webpack_require__(64765);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./adapters/helpers/Utils.js
var Utils = __webpack_require__(8996);
// EXTERNAL MODULE: ./adapters/helpers/Constants.js
var Constants = __webpack_require__(24036);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91038);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.test.js
var es_regexp_test = __webpack_require__(77601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__(33227);
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/createClass.js
var createClass = __webpack_require__(88361);
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(92222);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__(2707);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__(82772);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__(89554);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(54747);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__(69600);
// EXTERNAL MODULE: ./node_modules/isomorphic-fetch/fetch-npm-browserify.js
var fetch_npm_browserify = __webpack_require__(94301);
;// CONCATENATED MODULE: ./adapters/model/service/swiftype/search/SearchService.js
/* provided dependency */ var process = __webpack_require__(34155);















function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }














var SearchService = /*#__PURE__*/function () {
  function SearchService() {
    classCallCheck_default()(this, SearchService);
  }

  createClass_default()(SearchService, [{
    key: "searchDocument",
    value: function () {
      var _searchDocument = asyncToGenerator_default()( /*#__PURE__*/regenerator_default().mark(function _callee(query) {
        var registrationHeader, url, params, response, queryResult, searchResults, searchCategories, data, categories, _i, _categories, category;

        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                query = (0,Utils/* removeHtmlTag */.XP)(query);
                registrationHeader = new Headers();
                registrationHeader.append(Constants/* SearchServiceConstants.contentType */.SS.contentType, Constants/* SearchServiceConstants.json */.SS.json);
                this.market = process.env.MARKET.toLowerCase();
                this.swiftypeApiKey = "xqCksCXop4FKLKY6C5qP";
                this.swiftypeBaseUrl = Constants/* SearchServiceConstants.swiftypeBaseUrl */.SS.swiftypeBaseUrl;
                this.swiftypePath = Constants/* SearchServiceConstants.swiftypePath */.SS.swiftypePath;
                url = this.swiftypeBaseUrl + this.swiftypePath;
                params = {
                  'engine_key': this.swiftypeApiKey,
                  'q': query,
                  'filters': {
                    'product': {
                      'market': this.market
                    },
                    'page': {
                      'market': this.market
                    },
                    'article': {
                      'market': this.market
                    },
                    'collection': {
                      'market': this.market
                    },
                    'faq': {
                      'market': this.market
                    }
                  }
                };
                _context.next = 11;
                return fetch(url, {
                  method: 'POST',
                  headers: registrationHeader,
                  body: (0,Utils/* customJsonstringify */.Zl)(params)
                }).then();

              case 11:
                response = _context.sent;
                queryResult = {};
                searchResults = [];
                _context.next = 16;
                return response.json();

              case 16:
                data = _context.sent;
                // group so we can iterate on all results
                categories = ['product', 'page', 'article', 'collection'];

                for (_i = 0, _categories = categories; _i < _categories.length; _i++) {
                  category = _categories[_i];
                  searchResults = searchResults.concat(this.getEntriesForCategory(data, category));
                } // sort based on score


                searchResults.sort(this.compare);
                searchCategories = this.getResultCategories(data, ['faq']);
                queryResult.totalCount = data.record_count;
                queryResult.searchResults = searchResults;
                queryResult.searchResultsByCategory = data.records;
                queryResult.searchCategories = searchCategories;
                return _context.abrupt("return", queryResult);

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function searchDocument(_x) {
        return _searchDocument.apply(this, arguments);
      }

      return searchDocument;
    }()
  }, {
    key: "suggestResults",
    value: function () {
      var _suggestResults = asyncToGenerator_default()( /*#__PURE__*/regenerator_default().mark(function _callee2(query, excludedCategories) {
        var registrationHeader, url, documentTypes, categories, _i2, _categories2, category, params, response, queryResult, searchResults, searchCategories, data, _i3, _categories3, _category;

        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                registrationHeader = new Headers();
                registrationHeader.append(Constants/* SearchServiceConstants.contentType */.SS.contentType, Constants/* SearchServiceConstants.json */.SS.json);
                this.market = process.env.MARKET;
                this.swiftypeApiKey = "xqCksCXop4FKLKY6C5qP";
                this.swiftypeAutocompleteUrl = Constants/* SearchServiceConstants.swiftypeAutocompleteUrl */.SS.swiftypeAutocompleteUrl;
                url = this.swiftypeAutocompleteUrl;
                documentTypes = [];
                categories = ['product', 'page', 'article', 'collection', 'faq'];

                for (_i2 = 0, _categories2 = categories; _i2 < _categories2.length; _i2++) {
                  category = _categories2[_i2];

                  if (excludedCategories === undefined || excludedCategories.indexOf(category.toLowerCase()) < 0) {
                    documentTypes.push(category);
                  }
                }

                params = {
                  'engine_key': this.swiftypeApiKey,
                  'q': query,
                  'document_types': documentTypes,
                  'filters': {
                    'product': {
                      'market': [this.market]
                    },
                    'page': {
                      'market': [this.market]
                    },
                    'article': {
                      'market': [this.market]
                    },
                    'collection': {
                      'market': [this.market]
                    },
                    'faq': {
                      'market': [this.market]
                    }
                  }
                };
                _context2.next = 12;
                return fetch(url, {
                  method: 'POST',
                  headers: registrationHeader,
                  body: (0,Utils/* customJsonstringify */.Zl)(params)
                }).then();

              case 12:
                response = _context2.sent;
                queryResult = {};
                searchResults = [];
                _context2.next = 17;
                return response.json();

              case 17:
                data = _context2.sent;

                // group so we can iterate on all results
                for (_i3 = 0, _categories3 = categories; _i3 < _categories3.length; _i3++) {
                  _category = _categories3[_i3];

                  if (excludedCategories === undefined || excludedCategories.indexOf(_category.toLowerCase()) < 0) {
                    searchResults = searchResults.concat(this.getEntriesForCategory(data, _category));
                  }
                } // sort based on score


                searchResults.sort(this.compare);
                searchCategories = this.getResultCategories(data, excludedCategories);
                queryResult.totalCount = data.record_count;
                queryResult.searchResults = searchResults;
                queryResult.searchResultsByCategory = data.records;
                queryResult.searchCategories = searchCategories;
                return _context2.abrupt("return", queryResult);

              case 26:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function suggestResults(_x2, _x3) {
        return _suggestResults.apply(this, arguments);
      }

      return suggestResults;
    }()
  }, {
    key: "searchFaq",
    value: function () {
      var _searchFaq = asyncToGenerator_default()( /*#__PURE__*/regenerator_default().mark(function _callee3(query) {
        var registrationHeader, url, params, response, queryResult, searchResults, data;
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                registrationHeader = new Headers();
                registrationHeader.append(Constants/* SearchServiceConstants.contentType */.SS.contentType, Constants/* SearchServiceConstants.json */.SS.json);
                this.market = process.env.MARKET.toLowerCase();
                this.swiftypeApiKey = "xqCksCXop4FKLKY6C5qP";
                this.swiftypeBaseUrl = Constants/* SearchServiceConstants.swiftypeBaseUrl */.SS.swiftypeBaseUrl;
                this.swiftypePath = Constants/* SearchServiceConstants.swiftypePath */.SS.swiftypePath;
                url = this.swiftypeBaseUrl + this.swiftypePath;
                params = {
                  'engine_key': this.swiftypeApiKey,
                  'q': query,
                  'document_types': ['faq'],
                  'filters': {
                    'faq': {
                      'market': [this.market]
                    }
                  }
                };
                _context3.next = 10;
                return fetch(url, {
                  method: 'POST',
                  headers: registrationHeader,
                  body: (0,Utils/* customJsonstringify */.Zl)(params)
                }).then();

              case 10:
                response = _context3.sent;
                queryResult = {};
                searchResults = [];
                _context3.next = 15;
                return response.json();

              case 15:
                data = _context3.sent;
                // group so we can iterate on all results
                searchResults = searchResults.concat(this.getEntriesForCategory(data, 'faq')); // sort based on score

                searchResults.sort(this.compare);
                queryResult.totalCount = data.record_count;
                queryResult.searchResults = searchResults;
                queryResult = this.setFaqCategoriesAndResultsByCategory(queryResult, data.records);
                return _context3.abrupt("return", queryResult);

              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function searchFaq(_x4) {
        return _searchFaq.apply(this, arguments);
      }

      return searchFaq;
    }()
  }, {
    key: "setFaqCategoriesAndResultsByCategory",
    value: function setFaqCategoriesAndResultsByCategory(queryResult, records) {
      var searchCategories = [];
      var searchResultsByCategory = {};

      for (var record in records) {
        var _iterator = _createForOfIteratorHelper(records[record]),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var faq = _step.value;

            if (faq == null ? void 0 : faq.categories) {
              var _iterator2 = _createForOfIteratorHelper(faq.categories),
                  _step2;

              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var category = _step2.value;

                  if (searchResultsByCategory[category.toLowerCase()] === undefined) {
                    searchResultsByCategory[category.toLowerCase()] = [];
                  }

                  searchResultsByCategory[category.toLowerCase()].push(faq);

                  if (searchCategories.indexOf(category) < 0) {
                    searchCategories.push(category);
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      queryResult.searchResultsByCategory = searchResultsByCategory;
      queryResult.searchCategories = searchCategories;
      return queryResult;
    }
  }, {
    key: "getEntriesForCategory",
    value: function getEntriesForCategory(data, category) {
      var results = [];

      if (data.records[category]) {
        data.records[category].forEach(function (entry) {
          results.push(entry);
        });
      }

      return results;
    }
  }, {
    key: "getResultCategories",
    value: function getResultCategories(data, excludedCategories) {
      var categories = [];

      if (!excludedCategories) {
        excludedCategories = [];
      }

      if (data && data.info) {
        for (var property in data.info) {
          if (data.info[property].total_result_count > 0 && excludedCategories.indexOf(property) < 0) {
            categories.push(this.getCapitalizedValue(property));
          }
        }
      }

      return categories;
    }
  }, {
    key: "getCapitalizedValue",
    value: function getCapitalizedValue(value) {
      var capitalized = '';

      if (value) {
        capitalized = value.substr(0, 1).toUpperCase() + value.substr(1).toLowerCase();
      }

      return capitalized;
    }
  }, {
    key: "encodeQueryData",
    value: function encodeQueryData(data) {
      var ret = [];

      for (var d in data) {
        ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
      }

      return ret.join('&');
    }
  }, {
    key: "compare",
    value: function compare(a, b) {
      if (a._score > b._score) return -1;
      if (a._score < b._score) return 1;
      return 0;
    }
  }]);

  return SearchService;
}();

/* harmony default export */ var search_SearchService = (new SearchService()); // This export is for unit testing (do not remove) :

var SearchServiceTest = (/* unused pure expression or super */ null && (SearchService));
// EXTERNAL MODULE: ./adapters/helpers/Loader.js
var Loader = __webpack_require__(47322);
// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(29238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/SearchBar/SearchBar.js












/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */





var Icon = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 713).then(__webpack_require__.bind(__webpack_require__, 80713));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(80713)];
    }
  }
});




function SearchBar(props) {
  var onSearch = props.onSearch,
      placeholder = props.placeholder,
      searchActionTitle = props.searchActionTitle,
      commonSearchesLabel = props.commonSearchesLabel,
      isSpinning = props.isSpinning,
      defaultValue = props.defaultValue,
      isSearchFaqOnly = props.isSearchFaqOnly,
      isAutocompleteEnabled = props.isAutocompleteEnabled,
      searchTitle = props.searchTitle,
      searchCtaLabel = props.searchCtaLabel;

  var _useState = (0,react.useState)([]),
      autoCompleteResults = _useState[0],
      setAutocompleteResults = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isAutocompleteActivated = _useState2[0],
      setIsAutocompleteActivated = _useState2[1];

  var inputRef = (0,react.useRef)(null);
  var KEY_ESC = 27;
  var KEY_DOWN = 40;
  var KEY_UP = 38;
  (0,react.useEffect)(function () {
    return function cleanup() {
      document.removeEventListener('click', handleBlur);
    };
  }, []);

  var doAutocompleteSearch = /*#__PURE__*/function () {
    var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default().mark(function _callee(query) {
      var excludedCategories;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsAutocompleteActivated(true);
              excludedCategories = [];

              if (!isSearchFaqOnly) {
                excludedCategories.push('faq');
              } else {
                excludedCategories.push('product');
                excludedCategories.push('article');
                excludedCategories.push('collection');
                excludedCategories.push('page');
              }

              _context.next = 5;
              return search_SearchService.suggestResults(query, excludedCategories).then(function (searchResult) {
                manageAutoCompleteResult(searchResult);
              })["catch"](function () {
                closeAutocomplete();
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function doAutocompleteSearch(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var manageAutoCompleteResult = (0,react.useCallback)(function (results) {
    if (results && results.totalCount > 0 && results.searchResults) {
      document.addEventListener('click', handleBlur);
      var subResults = results.searchResults.slice(0, Constants/* SearchBarConstants.maximumAutocompleteResults */.pR.maximumAutocompleteResults);
      var resultsArray = subResults.map(function (item) {
        return getAutocompleteItem(item);
      });
      setAutocompleteResults(resultsArray);
    } else {
      setAutocompleteResults([]);
    }
  }, []);

  var getAutocompleteItem = function getAutocompleteItem(item) {
    if (item.highlight) {
      var title = item.name;

      if (item.highlight.text) {
        title = item.highlight.text;
      } else if (item.highlight.url && !item.highlight.name) {
        title = item.name;
      } else if (item.highlight.name) {
        title = item.highlight.name;
      }

      return {
        query: item.name,
        title: title
      };
    }

    return {
      query: item.name,
      title: item.title
    };
  };

  var closeAutocomplete = (0,react.useCallback)(function () {
    document.removeEventListener('click', handleBlur);
    setIsAutocompleteActivated(false);
    setAutocompleteResults([]);
  }, []);

  var handleInput = function handleInput(event) {
    var value = '';

    if (event.currentTarget && event.currentTarget.value) {
      value = event.currentTarget.value.trim();
    }

    if (value === '' || value.length <= 2) {
      closeAutocomplete();
    } else if (isAutocompleteEnabled) {
      doAutocompleteSearch(value);
    }
  };

  var handleBlur = function handleBlur() {
    closeAutocomplete();
  };

  var handleAutocompleteResultClick = (0,react.useCallback)(function (term) {
    if (inputRef.current) {
      inputRef.current.blur();
      inputRef.current.value = term;
    }

    closeAutocomplete();
    onSearch(term);
  }, [onSearch]);
  var handleMouseDown = (0,react.useCallback)(function (event) {
    event.preventDefault(); // keeps focus on input element
  }, []);

  var handleKeyDown = function handleKeyDown(event) {
    if (event.keyCode === KEY_ESC) {
      closeAutocomplete();
    } else if (event.keyCode === KEY_DOWN && isAutocompleteActivated) {
      event.preventDefault();
      event.stopPropagation();
      focusFirstAutocompleteSuggestion();
    }
  };

  var focusFirstAutocompleteSuggestion = function focusFirstAutocompleteSuggestion() {
    var suggestions = document.getElementsByClassName('ob-search-bar-autocomplete__result-item-button');

    if (suggestions && suggestions.length > 0) {
      suggestions[0].focus();
    }
  };

  var handleSuggestionItemKeyDown = function handleSuggestionItemKeyDown(event) {
    var selectedSuggestionItemIndex = getSelectedSuggestionItemIndex();

    if (event.keyCode === KEY_ESC) {
      inputRef.current.focus();
      closeAutocomplete();
      return;
    }

    if (event.keyCode === KEY_DOWN) {
      event.preventDefault();
      focusSuggestionItemByIndex(selectedSuggestionItemIndex + 1);
    } else if (event.keyCode === KEY_UP) {
      event.preventDefault();
      focusSuggestionItemByIndex(selectedSuggestionItemIndex - 1);
    }
  };

  var focusSuggestionItemByIndex = function focusSuggestionItemByIndex(index) {
    var suggestions = document.getElementsByClassName('ob-search-bar-autocomplete__result-item-button');

    if (suggestions && suggestions.length > 0) {
      if (index < 0) {
        index = suggestions.length - 1;
      }

      if (index >= suggestions.length) {
        index = 0;
      }

      suggestions[index].focus();
    }
  };

  var getSelectedSuggestionItemIndex = function getSelectedSuggestionItemIndex() {
    if (document.activeElement) {
      var index = document.activeElement.getAttribute('data-index');

      if (index) {
        return parseInt(index);
      }
    }

    return 0;
  };

  var handleSubmit = (0,react.useCallback)(function (event) {
    event.preventDefault();

    if (inputRef.current) {
      var term = '';

      if (inputRef.current.value) {
        term = inputRef.current.value.trim();
      }

      inputRef.current.blur();
      closeAutocomplete();
      onSearch(term);
    }
  }, [onSearch]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Suspense, {
    fallback: /*#__PURE__*/(0,jsx_runtime.jsx)(Loader["default"], {}),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
      className: "ob-search-bar-form",
      onSubmit: handleSubmit,
      children: [searchTitle !== '' && /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
        id: Constants/* SearchBarConstants.searchTitle */.pR.searchTitle,
        className: "ob-search-block__search-title",
        children: searchTitle.toUpperCase()
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "ob-search-bar",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
          type: Constants/* SearchBarConstants.text */.pR.text,
          id: Constants/* SearchBarConstants.searchText */.pR.searchText,
          name: Constants/* SearchBarConstants.searchText */.pR.searchText,
          ref: inputRef,
          autoComplete: "off",
          "aria-labelledby": Constants/* SearchBarConstants.searchTitle */.pR.searchTitle,
          onInput: handleInput,
          onKeyDown: handleKeyDown,
          placeholder: placeholder,
          defaultValue: defaultValue || ''
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
          "aria-label": isSpinning,
          type: Constants/* SearchBarConstants.submit */.pR.submit,
          title: searchActionTitle,
          className: "ob-search-bar-icon",
          children: [isSpinning ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "ob-search-bar-spinner",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {})
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Icon, {
            name: Constants/* SearchBarConstants.search */.pR.search,
            arialable: 'Search'
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "visuallyhidden",
            children: searchCtaLabel
          })]
        }), isAutocompleteActivated && autoCompleteResults && autoCompleteResults.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          role: Constants/* SearchBarConstants.list */.pR.list,
          onMouseDown: handleMouseDown,
          className: "ob-search-bar-autocomplete",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "ob-search-bar-autocomplete-title",
            children: commonSearchesLabel
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
            className: "ob-search-bar-autocomplete-results",
            children: autoCompleteResults.map(function (autocompleteResult, i) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: 'ob-search-bar-autocomplete__result-item',
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                  className: 'ob-search-bar-autocomplete__result-item-button event_search',
                  "data-index": i,
                  onKeyDown: handleSuggestionItemKeyDown,
                  "data-action-detail": (0,Utils/* stripHtml */.Vt)(autocompleteResult.title),
                  role: "link",
                  onClick: function onClick() {
                    return handleAutocompleteResultClick(autocompleteResult.query);
                  },
                  dangerouslySetInnerHTML: {
                    __html: browser_default().sanitize(autocompleteResult.title)
                  }
                })
              }, i);
            })
          })]
        })]
      })]
    }, defaultValue)
  });
}
SearchBar.defaultProps = {
  searchActionTitle: '',
  searchTitle: '',
  defaultValue: '',
  commonSearchesLabel: '',
  isAutocompleteEnabled: true
};

/***/ }),

/***/ 66477:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

/* globals self */ exports.Headers = self.Headers;
exports.Request = self.Request;
exports.Response = self.Response;
exports.fetch = self.fetch;

//# sourceMappingURL=whatwg-fetch.js.map

/***/ }),

/***/ 34155:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })

}]);